import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Box,
  Typography,
  Container,
  useTheme,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";

const SearchResultsPage = () => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const searchParams = new URLSearchParams(location.search);
  const searchUrl = searchParams.get("url");
  const isLoading = searchParams.get("loading") === "true";

  const [showIframe, setShowIframe] = useState(false);

  useEffect(() => {
    if (searchUrl) {
      setShowIframe(true);
    }
  }, [searchUrl]);

  return (
    <Container maxWidth="xl">
      <Box
        sx={{
          textAlign: "center",
          my: { xs: 2, sm: 3, md: 4 },
          px: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "center",
            justifyContent: "center",
            gap: { xs: 2, sm: 3 },
          }}
        >
          <Box
            component="img"
            src="/Assets/admin-ajax.png"
            alt="Global Service Travel Agents Logo"
            draggable="false"
            sx={{
              width: {
                xs: "100px",
                sm: "140px",
                md: "180px",
              },
              height: "auto",
              objectFit: "contain",
              transition: "all 0.3s ease",
              filter: "drop-shadow(0 4px 6px rgba(0,0,0,0.2))",
              borderRadius: "8px",
              transform: "scale(1)",
              "&:hover": {
                transform: "scale(1.05)",
                filter: "drop-shadow(0 6px 8px rgba(0,0,0,0.3))",
              },
            }}
          />
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: theme.palette.primary.main,
              fontSize: {
                xs: "1rem",
                sm: "1.2rem",
                md: "1.5rem",
              },
              letterSpacing: "-0.02em",
              whiteSpace: { xs: "normal", sm: "nowrap" },
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: { xs: "100%", sm: "60%", md: "unset" },
            }}
          >
            Global Service Travel Agents
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          height: {
            xs: "calc(100vh - 180px)",
            sm: "calc(100vh - 160px)",
            md: "calc(100vh - 140px)",
          },
          width: "100%",
          borderRadius: { xs: 1, sm: 2 },
          overflow: "hidden",
          boxShadow: theme.shadows[3],
          mb: { xs: 2, sm: 3, md: 4 },
        }}
      >
        {isLoading && !searchUrl ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              backgroundColor: theme.palette.background.paper,
            }}
          >
            <CircularProgress size={isMobile ? 40 : 60} />
            <Typography
              variant="body1"
              sx={{
                ml: 2,
                fontSize: { xs: "0.875rem", sm: "1rem" },
                color: theme.palette.text.secondary,
              }}
            >
              Searching for flights...
            </Typography>
          </Box>
        ) : showIframe ? (
          <iframe
            src={searchUrl}
            title="Search Results"
            style={{
              width: "100%",
              height: "100%",
              border: "none",
              backgroundColor: theme.palette.background.paper,
            }}
          />
        ) : (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              p: { xs: 2, sm: 3 },
              backgroundColor: theme.palette.background.paper,
            }}
          >
            <Typography
              variant="body1"
              color="error"
              sx={{
                fontSize: { xs: "0.875rem", sm: "1rem" },
              }}
            >
              No search results found.
            </Typography>
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default SearchResultsPage;
